import type { TableColumnConfig } from '@pct-ng/feature-table-material';
import type { TranslocoService } from '@jsverse/transloco';

export function createLanguagesColumn<T extends { languages: string[] | null }>(
  i18nPrefix: string,
  translocoService: TranslocoService,
): TableColumnConfig<T> {
  return {
    field: 'languages',
    id: 'languages',
    label: `${i18nPrefix}LANGUAGES`,
    cellContent: (row: T) =>
      row.languages
        ?.map(code => translocoService.translate(`ng/i18n.LANGUAGE_CODE.${code}`))
        ?.join(', ') ?? '',
  };
}
